const NightCoverageEnum = {
  COVERED: 'covered',
  CLOSED: 'closed',
  GAP: 'gap',
  DOUBLE: 'double',
};

export default NightCoverageEnum;
